import { Component, OnInit, ViewChild, OnDestroy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { MenuItem, MessageService } from 'primeng/api';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { crop_Datas } from '../../../../models/farmer-land.model';
import { FarmerLandDetailService } from 'src/app/services/farmer-land-detail.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import exifr from 'exifr';
import piexifjs from 'piexifjs';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { ReportsService } from 'src/app/services/reports.service';
import { DatePipe } from '@angular/common';
// Hypothetical service to fetch NOC data

@Component({
  selector: 'app-uploaded-noc-for-survey',
  templateUrl: './uploaded-noc-for-survey.component.html',
  styleUrls: ['./uploaded-noc-for-survey.component.scss'],
  providers: [DatePipe]
})

export class UploadedNocForSurveyComponent implements OnInit {
  @ViewChild('farmerPreEstimateSurveyTable', { static: true })
  public farmerPreEstimateSurveyTable: Table;
  @ViewChild('geolocationsarrayTable', { static: true })
  public geolocationsarrayTable: Table;
  public farmerUHBVNpvData: any = [];
  mobileFarmerUHBVNpvData: any = [];
  displayUHBVNpvDialog: boolean = false;
  isSubmitted: boolean = false;
  submitEstimateForm: FormGroup;
  latitude: any;
  longitude: any;
  geolocationsarray: any = [];
  overlays: any = [];
  mapEnable = false;
  public vendorRegId: any;
  selectedWatersourceType: string;
  componentList: any = [];
  public userId: any;
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  options = {
    center: { lat: 29.0588, lng: 76.0856 },
    zoom: 17,
    mapTypeId: google.maps.MapTypeId.SATELLITE,
    draggable: false,
    // icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
  };

  public selectedRow: any;
  public selectedNonRecOpt: any;
  public nonRecOptionList: any = [];
  // public farmerMobNo: any;
  // public programName: any;

  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId!: string;
  public webcamImage!: WebcamImage;
  public videoOptions: MediaTrackConstraints = {};
  public imageCaptured = false;
  public errors: WebcamInitError[] = [];
  private trigger: Subject<void> = new Subject<void>();
  @Output()
  public pictureTaken = new EventEmitter<WebcamImage>();
  displayBasic: boolean = false;
  displayCameraComponent: any = false;
  selctedFileType: any;
  documentList: any = [];
  insertPondAttachments: any = [];
  selectedCropType: any;
  selectedCorpModel: crop_Datas;
  selectedCorpModelList: any;
  selectedNodes1: any[] = [];
  cropTypeList: any[];
  allSchemeMaster: any[] = [];
  waterSourceList: any[];
  private nextWebcam: Subject<boolean | string> = new Subject<
    boolean | string
  >();
  waterSourceNames: any;
  ProgramID: any;
  cropBasedNames: any;
  error: string;
  // vendorCode: any;
  allAttachementsList: any = [];
  attachementDisplayName: any = [];
  imageError: string;
  uploadOptions: any[];
  autoId: any;
  appId: any;
  editBilledData: boolean = false;
  coordinateError: any;
  public multiSortMeta: any;
  ipAddress: any = '000.000.000';
  landArea: number = 0;
  surveyArea: number = null;

  public refreshLocation: any;
  appVerificationItems: MenuItem[];
  appVerificationModel: any[]

  public isGPSError: boolean = false;
  public loading: boolean = false;
  public subscriptions: any = []
  public subjectSub: any;
  public selectedYear: any;

  public componentMasterList: any = [];
  public applicationStatusList: any = [];

  public consentRecommend: any = null;
  public isJeLogin: boolean = false;
  public isXenLogin: boolean = false;

  public selectedVillage: any;
  public financialYearList: any = [];
  public miVendorList: any = [];
  public filteredmiVendorList: any = [];
  public villageList: any = [];
  public filteredVillage: any[];

  public xenRemarks: any;
  public XenRecommended: any;

  constructor(
    private loader: AppLoaderService,
    private vendorService: VendorDashboardService,
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private flService: FarmerLandDetailService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private cryptoJsService: CryptoJsService,
    private farmerAppSer: FarmersApplicationService,
    private ipService: IpAddressService,
    public cd: ChangeDetectorRef,
    public router: Router,
    private service: BaseService,
    private reportsService: ReportsService,
    private datePipe: DatePipe,
  ) {
    (this.uploadOptions = [
      { name: 'Field Photo', code: 'field_photo' },
      { name: 'Land Paper Photo', code: 'land_paper' },
      { name: 'Bill Photo', code: 'bill_photo' },
      { name: 'PV Performa Photo', code: 'pv_performa_photo' },
      { name: 'Others', code: 'others' },
    ]);
  }

  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    // const token: any = this.tokenService.retrieve();
    this.vendorRegId = JSON.stringify(token?.officeCode);
    // let payload = atob(token?.value?.authToken?.split('.')[1]);

    // this.onCapture();
    // this.getCurrentLocation();
    // this.addOverlay();

    const tokenData = sessionStorage.getItem('token') ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'))) : {};
    // console.log('token.role', tokenData?.role)
    if (tokenData && (tokenData.role == 'JE')) {
      this.isJeLogin = true;
      this.isXenLogin = false;
    }
    if (tokenData && (tokenData.role == 'XEN')) {
      this.isJeLogin = false;
      this.isXenLogin = true;
    }

    this.loadData(this.userId);
    // this.loadDataAndApplyFilter();

    this.getIP();
    this.getCorpType();

    setTimeout(() => {
      this.componentMasterList = [
        {
          Program_Id: 1,
          Program_Name: 'Portable Sprinkler',
          Active: true,
        },
        {
          Program_Id: 2,
          Program_Name: 'Mini Sprinkler',
          Active: true,
        },
        {
          Program_Id: 3,
          Program_Name: 'Drip',
          Active: true,
        },
      ];
      this.applicationStatusList = [
        {
          code: 1,
          name: 'MIS Installation Recommended',
          Active: true,
        },
        {
          code: 0,
          name: 'MIS Installation Not Recommended',
          Active: true,
        },
      ];

      this.nonRecOptionList = [
        { name: 'Bill Not provided', code: '1' },
        { name: 'Latitude & Longitude mismatched', code: '2' },
        { name: 'MIS not operational', code: '3' },
        { name: 'Billed items quantity mismatched', code: '4' },
        { name: 'others', code: '5' },
      ]
    }, 100);

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'UHBVN_PV_APP');
        },
      },
      // {
      //   label: 'Download Pdf',
      //   icon: 'pi pi-fw pi-download',
      //   command: () => {
      //     this.downloadSheetAsPdf(
      //       this.appVerificationModel,
      //       'Pre_estimate_survey_file'
      //     );
      //   },
      // },
    ];
    // setTimeout(() => {
    //   console.log(this.overlays, 'geeee')
    //   if(this.overlays.length >=3){
    //     this.onDelect(0)
    //   }
    //   // else {
    //   //   this.overlays.forEach((val, index) => {
    //   //     if(val?.title == 'Coordinate 1'){
    //   //       this.overlays.splice(index, 1);
    //   //       this.geolocationsarray = [];
    //   //       this.onSave();
    //   //     }
    //   //   })
    //   // }
    // }, 5000)
    this.submitEstimateForm = this.fb.group({
      mobileNo: [{ value: '', disabled: this.isXenLogin }, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      aadharNo: [{ value: '', disabled: this.isXenLogin }, [Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
      farmersName: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      fatherName: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      village: [{ value: this.selectedVillage, disabled: this.isXenLogin }, Validators.required],
      address: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      division: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      vendor: [{ value: '', disabled: this.isXenLogin }, Validators.required],

      area: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      finyear: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      letterDate: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      sdo: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      letterNo: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      misInstalled: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      cropType: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      cropId: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      killNumber: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      performaQunatity: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      appStatus: [{ value: '', disabled: this.isXenLogin }, Validators.required],
      checkBoxRec: [{ value: '', disabled: this.isXenLogin },],
      nonRecReason: [{ value: '', disabled: this.isXenLogin },],
      remarksNonRec: [{ value: '', disabled: this.isXenLogin },],
      jePVRemarks: [{ value: '', disabled: this.isXenLogin },],

      // waterSource: ['', Validators.required],
      // ph: ['', Validators.required],
      // ec: ['', Validators.required],
      // waterReq: ['', Validators.required],
      // plantSpacing: ['', Validators.required],
      // rowSpacing: ['', Validators.required],
    });
    // this.farmerPreEstimateSurveyTable.filters['Status_Ar'] = [
    //   { value: 'P', matchMode: 'equals', operator: 'and' },
    // ];
    this.multiSortMeta = [];
    this.multiSortMeta.push({ field: 'AssignedDate', order: 1 });
    WebcamUtil.getAvailableVideoInputs().then(
      (mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      }
    );

    this.getFinancialYearList();
    this.getVillageData();
  }

  getFinancialYearList() {
    this.reportsService.getFinanacialYearList()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.financialYearList = data;
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'error Message',
            detail: `${err}`,
          });
        }
      })
  }

  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
  }

  getVillageData() {
    this.loader.start();
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      this.loader.close();
      // console.log(res);
      this.villageList = res;
      this.filteredVillage = [...this.villageList]
      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
  }

  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.miVendorList.length; i++) {
      const vendor = this.miVendorList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredmiVendorList = filtered;
  }

  onSelectProgramme(type, venCode) {
    this.f['vendor'].reset();

    let programme = this.f['misInstalled'].value;

    this.getVendorDropdown(programme, type, venCode);
  }

  getVendorDropdown(programId, type, venCode) {
    this.loader.start();
    this.farmerAppSer
      .getAllMIvenders(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.miVendorList = res;

          if(type == 'update'){
            let selVendor = this.miVendorList?.filter(val => val?.Vendor_Code == venCode)[0];
            this.f.vendor.setValue(selVendor);
          }

        },
        error: (err) => {
          this.loader.close();
          this.miVendorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  loadDataAndApplyFilter() {
    this.ngOnDestroy();

    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        this.selectedYear = res;
        this.loadData(this.userId);
        this.farmerPreEstimateSurveyTable.filters['Fin_Year'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Application No': d?.AppId,
          'Farmer Name': d?.Farmer_Name,
          'Mobile No': d?.FarmerMobile,
          'Father_Name': d?.Father_Name,
          'Village': d?.VillageName,
          'Vendor Name': d?.VendorFullName,
          'Programme Name': d?.Program_Name,
          'Killa No': d?.KillaNo,
          'Totoal Area (in Acre)': d?.AreaAcre,
          'Fin Year': d?.Fin_Year,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onSelectAppStatus(val) {
    // recommended 1
    if (val?.value == 1) {
      this.submitEstimateForm.controls['checkBoxRec'].setValidators([Validators.required]);
      this.submitEstimateForm.controls['nonRecReason'].clearValidators();
      this.submitEstimateForm.controls['remarksNonRec'].clearValidators();
    }
    // not recommended 0
    else if (val?.value == 0) {
      this.submitEstimateForm.controls['nonRecReason'].setValidators([Validators.required]);
      this.submitEstimateForm.controls['remarksNonRec'].clearValidators();
      this.submitEstimateForm.controls['checkBoxRec'].clearValidators();
    }
    this.submitEstimateForm.controls['checkBoxRec'].updateValueAndValidity();
    this.submitEstimateForm.controls['nonRecReason'].updateValueAndValidity();
    this.submitEstimateForm.controls['remarksNonRec'].updateValueAndValidity();
  }

  onSelectNonRecOption(val) {
    if (this.submitEstimateForm.value.nonRecReason?.code == 5) {
      this.submitEstimateForm.controls['checkBoxRec'].clearValidators();
      this.submitEstimateForm.controls['remarksNonRec'].setValidators([Validators.required]);
      // this.submitEstimateForm.controls['nonRecReason'].clearValidators();
    } else {
      this.submitEstimateForm.controls['checkBoxRec'].clearValidators();
      this.submitEstimateForm.controls['remarksNonRec'].clearValidators();
      // this.submitEstimateForm.controls['nonRecReason'].setValidators([Validators.required]);
    }
    this.submitEstimateForm.controls['checkBoxRec'].updateValueAndValidity();
    this.submitEstimateForm.controls['remarksNonRec'].updateValueAndValidity();
  }


  // ============================================

  onRefreshCurrentLocation() {
    // console.log("refreshLocation")
    this.overlays.forEach((val, index) => {
      if (val?.title == "Current Location") {
        this.overlays.splice(index, 1);
      }
    })
    this.getCurrentLocation();
  }

  getCurrentLocation() {
    // console.log(this.overlays)
    let overlay = this.overlays;
    let mapEnable = this.mapEnable;
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      function success(pos) {
        const crd = pos.coords;
        const obj = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.options.center = obj;
        // const image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

        const currentLocationMarker = new google.maps.Marker({
          position: { lat: obj?.lat, lng: obj?.lng },
          title: 'Current Location',
          icon: '../../../assets/map/location-icon-5.png',
        });

        overlay.push(currentLocationMarker)
        // console.log(overlay);


        // instant.geolocationsarray.push(obj)
        // instant.onSave()
        // instant.addOverlay()
        instant.mapEnable = true;
      }

      function error(err) {
        instant.isGPSError = true;
        let detailsMsg = '';
        if (err?.message == 'User denied Geolocation') {
          detailsMsg = 'Please enable Geolocation access.'
        } else {
          detailsMsg = 'Please Refresh the Current Location.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg,
        });
        // console.log(`ERROR1(${err.code}): ${err.message}`);
      }

      // this.mapEnable = true;
      navigator.geolocation.getCurrentPosition(success, error, options);
      // this.addOverlay();
    }
  }

  get f() {
    return this.submitEstimateForm.controls;
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  loadData(userId) {
    // this.loader.start();
    this.loading = true;
    let sub = this._personalDetalSer
      .getUHBVNAppByXEN(userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userId,
            'UHBVN PV',
            '',
            new Date(),
            'Success'
          );

          if (data.length > 0) {
            this.farmerUHBVNpvData = data;
            this.appVerificationModel = this.farmerUHBVNpvData;
            this.mobileFarmerUHBVNpvData = data;
            // this.mobileFarmerUHBVNpvData = this.farmerUHBVNpvData.filter(val => val.Fin_Year == this.selectedYear);

          }
          else {
            this.farmerUHBVNpvData = [];
            this.appVerificationModel = []
            this.mobileFarmerUHBVNpvData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userId,
            'UHBVN PV',
            '',
            new Date(),
            err
          );
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  getCorpType() {
    this.flService
      .GetCorpType()
      .pipe(first())
      .subscribe({
        next: (files) => {
          this.cropTypeList = files;
          // console.log(this.cropTypeList, 'this.cropTypeList');
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Corp Type Details not loaded.',
          });
        },
      });
  }

  getCropTypeName(event) {
    const data = this.cropTypeList.find((element) => element.data == event);
    if (data) {
      this.cropBasedNames = data.children;
    } else {
      this.cropBasedNames = [];
    }
  }

  selectPreSurveyData(event) { }

  onCloseDialog() {
    this.isGPSError = false;
    clearInterval(this.refreshLocation);
    this.displayUHBVNpvDialog = false;
    this.mapEnable = false;
    this.geolocationsarray = [];
    this.documentList = [];
    this.isSubmitted = false;
    this.submitEstimateForm.reset();
    this.landArea = 0;
    this.surveyArea = null;
    this.addOverlay();
    this.overlays = this.overlays.filter(val => {
      return !val?.title?.includes('Coordinate')
    });
  }
  onCapture() {
    let instant = this;
    this.coordinateError = '';
    if ('geolocation' in navigator) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      function success(pos) {
        let isInvalid = instant.geolocationsarray.find((data) => {
          if (
            data.lat == pos.coords.latitude &&
            data.lng == pos.coords.longitude
          ) {
            return data;
          }
        });

        if (isInvalid) {
          instant.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:
              'Please move to a different location to get new coordinates.',
          });
          return;
        }

        const crd = pos.coords;
        const obj = {
          CornerID: instant.geolocationsarray.length + 1,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };

        instant.geolocationsarray.push(obj);
        
        // Check for self-intersections before allowing the polygon creation
        if (instant.isSelfIntersecting(instant.geolocationsarray)) {
          // this.onDelect(this.geolocationsarray.length - 1);
          instant.geolocationsarray.pop();
          alert('Polygon is invalid due to intersecting edges. Please redraw.');
          return;
        }else {
          instant.onSave();
        }
      }

      function error(err) {
        let detailsMsg = '';
        if (err?.message == 'User denied Geolocation') {
          detailsMsg = 'Please enable Geolocation access'
        } else {
          detailsMsg = 'Please capture again.'
        }
        instant.messageService.add({
          severity: 'error',
          summary: err.message,
          detail: detailsMsg
          ,
        });
        // console.log(`ERROR(${err.code}): ${err.message}`);
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
    }
  }

  isSelfIntersecting(coordsArray) {
    for (let i = 0; i < coordsArray.length - 1; i++) {
      for (let j = i + 2; j < coordsArray.length; j++) {
        // Prevent checking consecutive edges or the last edge with the first one
        if (i === 0 && j === coordsArray.length - 1) continue;
        if (this.doLinesIntersect(coordsArray[i], coordsArray[i + 1], coordsArray[j], coordsArray[(j + 1) % coordsArray.length])) {
          return true;
        }
      }
    }
    return false;
  }

  doLinesIntersect(p1, q1, p2, q2) {
    // Helper function to calculate orientation of the points
    function orientation(p, q, r) {
      let val = (q.lat - p.lat) * (r.lng - q.lng) - (q.lng - p.lng) * (r.lat - q.lat);
      if (val === 0) return 0; // collinear
      return (val > 0) ? 1 : 2; // clock or counterclockwise
    }

    // Check the four orientations needed for the general and special cases
    let o1 = orientation(p1, q1, p2);
    let o2 = orientation(p1, q1, q2);
    let o3 = orientation(p2, q2, p1);
    let o4 = orientation(p2, q2, q1);

    // General case
    if (o1 !== o2 && o3 !== o4) return true;

    // Special cases
    // p1, q1, p2 are collinear and p2 lies on segment p1q1
    if (o1 === 0 && this.onSegment(p1, p2, q1)) return true;

    // p1, q1, q2 are collinear and q2 lies on segment p1q1
    if (o2 === 0 && this.onSegment(p1, q2, q1)) return true;

    // p2, q2, p1 are collinear and p1 lies on segment p2q2
    if (o3 === 0 && this.onSegment(p2, p1, q2)) return true;

    // p2, q2, q1 are collinear and q1 lies on segment p2q2
    if (o4 === 0 && this.onSegment(p2, q1, q2)) return true;

    return false;
  }

  onSegment(p, q, r) {
    return q.lng <= Math.max(p.lng, r.lng) && q.lng >= Math.min(p.lng, r.lng) &&
      q.lat <= Math.max(p.lat, r.lat) && q.lat >= Math.min(p.lat, r.lat);
  }

  onDelect(i) {
    // console.log(this.geolocationsarray)
    this.geolocationsarray.splice(i, 1);
    for (let index = 0; index < this.geolocationsarray.length; index++) {
      this.geolocationsarray[index].CornerID = index + 1;
    }
    // if (this.geolocationsarray.length == 0) {
    //   // this.mapEnable = false;
    //   this.mapEnable = true;
    // } else {
    this.options.center = this.geolocationsarray[0];
    this.mapEnable = false;
    this.mapEnable = true;
    this.overlays = [];
    this.geolocationsarray.forEach((row, index) => {
      this.addMarkers(row, index);
    });
    this.addOverlay();
    // }
  }

  onSave() {
    this.mapEnable = false;
    this.mapEnable = true;
    this.options.center = this.geolocationsarray[0];
    this.overlays = [];
    this.geolocationsarray.forEach((row, index) => {
      this.addMarkers(row, index);
    });
    this.addOverlay();
  }

  onNext() { }
  mobileSearch(value) {
    this.mobileFarmerUHBVNpvData =
      this.farmerUHBVNpvData.filter((data: any) => {
        if (
          data.appID.toLowerCase().includes(value.toLowerCase()) ||
          data.FarmerName.toLowerCase().includes(value.toLowerCase()) ||
          data.ProgrammeName.toLowerCase().includes(value.toLowerCase()) ||
          data.district.toLowerCase().includes(value.toLowerCase()) ||
          data.village.toLowerCase().includes(value.toLowerCase()) ||
          data.block.toLowerCase().includes(value.toLowerCase()) ||
          data.Status_Ar.toLowerCase().includes(value.toLowerCase())
        ) {
          return data;
        }
      });
  }
  addOverlay() {
    this.overlays.forEach((val, index) => {
      if (val?.fillColor) {
        this.overlays.splice(index, 1);
      }
    })

    this.overlays.push(
      new google.maps.Polygon({
        paths: this.geolocationsarray,
        strokeOpacity: 0.5,
        strokeWeight: 1,
        fillColor: '#1976D2',
        fillOpacity: 0.35,
      })
    );
    // console.log(this.overlays);
    if (this.geolocationsarray.length >= 3) {
      let polygon = new google.maps.Polygon({ paths: this.geolocationsarray })
      let area = this.calculateLandArea(polygon.getPath());
      this.landArea = Number((0.000247105 * area).toFixed(2));
      // console.log("Calculated Area",this.landArea);
    }
    // this.onRefreshCurrentLocation();
  }

  calculateLandArea(polygon) {
    return google.maps.geometry?.spherical.computeArea(polygon)
  }

  removeOverlay() {
    this.overlays.pop().setMap(null);
  }
  addMarkers(row: any, index) {
    this.overlays.push(
      new google.maps.Marker({
        position: { lat: row?.lat, lng: row?.lng },
        title: 'Coordinate ' + row?.CornerID,
        draggable: false,
        crossOnDrag: false
      })
    );
  }

  onDrag(event) {
    // console.log("event", event, event?.overlay?.position?.lat(), event?.overlay?.position?.lng());
    // console.log(this.overlays);

    let index = -1;
    index = event?.overlay?.title ? event?.overlay?.title.split(' ')[1] : -1;
    if (index >= 1) {
      // console.log(this.geolocationsarray, index, this.geolocationsarray[index-1], this.geolocationsarray[index-1]['lat']);
      this.geolocationsarray[index - 1].lat = event?.overlay?.position?.lat();
      this.geolocationsarray[index - 1].lng = event?.overlay?.position?.lng();

      this.removeOverlay();
      this.addOverlay();
    }
  }

  showBasicDialog() {
    this.displayBasic = true;
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.imageCaptured = true;
    this.pictureTaken.emit(webcamImage);
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public uploadPicture() {
    const arr = this.webcamImage.imageAsDataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    exifr
      .parse(this.webcamImage.imageAsDataUrl)
      .then((output) => {//console.log('Camera:', output)
      });
    // console.log(piexifjs.load(this.webcamImage.imageAsDataUrl));
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const file: File = new File([u8arr], this.selctedFileType + '.jpeg', {
      type: mime,
    });
    let data = new FormData();
    data.append('file', file);
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let phNo = JSON.parse(payload)?.sub;
    // this.route.queryParams
    //   .subscribe(params => {
    // if (params.autoId) {
    this._personalDetalSer
      .uploadFile(data, phNo, this.selctedFileType.code)
      .subscribe((resp: any) => {
        if (resp.statusCode == 200) {
          const fileName = `preEstimateSurvey_${new Date().getTime()}`;
          this.documentList.push({
            attachment: resp.data,
            attachmentRawUrl: this.webcamImage.imageAsDataUrl,
            document_type: this.selctedFileType.name,
            displayName: fileName,
            name: this.selctedFileType.name,
            // this.selctedFileType.code === 'farmer_photo'
            //   ? 'Farmer Photo'
            //   : this.selctedFileType.code === 'water_source'
            //     ? 'Water Source'
            //     : this.selctedFileType.code === 'land_photo'
            //       ? 'Land Photo'
            //       : this.selctedFileType.code === 'others'
            //         ? 'Others'
            //         : 'Component Photo',
            isUploaded: false,
          });

          // let documentListObject = {
          //   // 'appId': this.cryptoJsService.DecryptData(params.appId),
          //   'documentList': this.documentList
          // }
          // sessionStorage.setItem('documentList', JSON.stringify(documentListObject));
          this.selctedFileType = '';
          this.retake();
          this.displayCameraComponent = false;
        } else {
          // console.log('Error');
        }
        this.selctedFileType = '';
      });
    // });
  }
  retake() {
    this.imageCaptured = false;
  }
  onCaptureImage() {
    this.displayCameraComponent = true;
  }
  onCloseImageDialog() {
    this.displayCameraComponent = false;
    this.imageCaptured = false;
  }
  getImagesArray() {
    if (this.documentList.length == 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'ERROR_MESSAGE',
        detail: 'Images are Mandatory',
      });
      return;
    } else {
      this.uploadOptions.forEach((option) => {
        if (option.code != 'others') {
          let filtered = this.documentList.filter((doc) => {
            return doc.document_type == option.name;
          });
          if (filtered?.length == 0) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Atleast one ' + option.name + ' is Needed!',
            });
            return;
          }
        }
      });
    }
  }


  submitSurveyDetails() {
    let existImage = true;
    this.isSubmitted = true;
    if (this.submitEstimateForm.valid) {
      if (this.geolocationsarray.length < 4) {
        this.coordinateError = 'PLEASE_PROVIDE_ATLEAST_4_GPS_COORDINATES';
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Please provide atleast 4 GPS Coordinates',
        });
        return;
      }
      // else if (this.landArea - this.surveyArea >= 1) {
      //   this.messageService.add({
      //     severity: 'error',
      //     summary: 'Error Message',
      //     detail: `Calculated Area (${this.landArea}) is much greater than Survey Area (${this.surveyArea}). Please recapture the coordinates.`,
      //   });
      //   return;
      // } 
      else if (this.documentList.length == 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Images are Mandatory',
        });
        return;
      } else {
        this.uploadOptions.forEach((option) => {
          if (option.code != 'others') {
            let filtered = this.documentList.filter((doc) => {
              return doc.document_type == option.name;
            });
            if (filtered?.length == 0) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Atleast one ' + option.name + ' is Needed!',
              });
              existImage = false;
            }
          }
        });
        let attachemntArray = [];
        if (!existImage) {
          return;
        }
        for (let index = 0; index < this.documentList.length; index++) {
          const obj = {
            attachmentsDoc: this.documentList[index].attachment,
            documentType: this.documentList[index].document_type,
          };
          attachemntArray.push(obj);
        }
        let geoCoordinates = [];
        for (let index = 0; index < this.geolocationsarray.length; index++) {
          const gpsObj = {
            CornerID: index + 1,
            latitude: this.geolocationsarray[index].lat,
            longitude: this.geolocationsarray[index].lng,
          };
          geoCoordinates.push(gpsObj);
        }

        let surveyData = this.submitEstimateForm.value;
        const reqBody = [
          {
            "appId": this.selectedRow?.AppId,
            "cropId": surveyData?.cropId,
            "cropTypeId": surveyData?.cropType,
            "area": surveyData?.area,
            "killaNo": surveyData?.killNumber,
            "vendor": JSON.stringify(surveyData?.vendor?.Vendor_Code),
            "farmerMobile": surveyData?.mobileNo,
            "aadhaarNo": surveyData?.aadharNo,
            "farmer_Name": surveyData?.farmersName,
            "father_Name": surveyData?.fatherName,
            "fin_Year": surveyData?.finyear,
            "village": surveyData?.village?.Code,
            "networkId": this.ipAddress,
            "terminalId": this.ipAddress,
            "division": surveyData?.division,
            "residenceOf": surveyData?.address,
            "typeOfMISInstalled": surveyData?.misInstalled ? surveyData?.misInstalled : 0,
            "performaQuantity": Number(surveyData?.performaQunatity),
            "userId": this.userId,
            "jE_Recommended": surveyData?.appStatus,
            "jE_Remark": surveyData?.appStatus == 0 ? (surveyData?.nonRecReason?.code == 5 ? (surveyData?.remarksNonRec ? surveyData?.remarksNonRec : '') : surveyData?.nonRecReason?.name) : '',
            "xen_Recommended": 0,
            "xeN_Remark": "string",
            "letterDate": surveyData?.letterDate ? this.datePipe.transform(new Date(surveyData?.letterDate), 'yyyy-MM-dd') : surveyData?.letterDate,
            "sdo": surveyData?.sdo,
            "letterNo": surveyData?.letterNo,
            "insertServayAttachments": attachemntArray,
            "gpsCoordinates": geoCoordinates,
            "DocPath": ""
          },
        ];

        this.submitUHBVNSurvey(reqBody);
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please fill all the mandatory feilds',
      });
    }
  }
  removeImg(i) {
    this.documentList.splice(i, 1);
  }

  rowBackgroundColor(row) {
    if (this.isJeLogin && row.JE_Status == 'Done') {
      return '#b9ecb9';
    } else if (this.isXenLogin && row.XEN_Status == 'Done') {
      return '#b9ecb9';
    } else return '#f9cece';
  }

  addEstimation(data) {
    this.getCurrentLocation();
    this.addOverlay();
    this.refreshLocation = setInterval(() =>
      this.onRefreshCurrentLocation(), 6000)

    // setTimeout(() => {
    //   if(!this.isGPSError){
    //     this.refreshLocation = setInterval(() =>
    //     this.onRefreshCurrentLocation(), 5000)
    //   }
    // }, 7000)



    this.displayUHBVNpvDialog = true;
    this.geolocationsarray = [];
    this.selectedRow = data;

    // this.programmeAppId = data.appID;
    // this.programmeFarmerName = data.FarmerName;
    // this.ProgramID = data.ProgramID;
    // this.vendorCode = data.Vendor_Code;
    this.isSubmitted = false;
    this.surveyArea = data.AreaAcre;
    // this.applyConditionalValidation(data);
  }

  updateEstimation(data) {
    this.autoFillDetails(data);
    // if(this.isXenLogin){
    // }else if(this.isJeLogin){
    //   this.autoFillDetails(data);
    // }
  }

  autoFillDetails(data){
    this.geolocationsarray = [];

    this.geolocationsarray = [];
    this.selectedRow = data;

    this.isSubmitted = false;
    this.displayUHBVNpvDialog = true;
    
    this.loader.start();
    this._personalDetalSer
      .getUHBVN_Letter_MI_PV(data?.AppId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data) {
            this.surveyArea = data.Area;
      // village
      // vendor
            this.f.mobileNo.setValue(data.FarmerMobile);
            this.f.aadharNo.setValue(data.AadhaarNo);
            this.f.farmersName.setValue(data.Farmer_Name);
            this.f.fatherName.setValue(data.Father_Name);
            this.f.address.setValue(data.ResidenceOf);
            this.f.division.setValue(data.Division);
            this.f.finyear.setValue(data.Fin_Year);
            this.f.letterDate.setValue(new Date(data.LetterDate));
            this.f.sdo.setValue(data.SDO);
            this.f.letterNo.setValue(data.LetterNo);
            this.f.cropType.setValue(data.CropTypeId);
            this.f.cropId.setValue(data?.CropId);
            this.f.killNumber.setValue(data?.KillaNo);
            this.f.area.setValue(data?.Area);
            this.f.performaQunatity.setValue(data?.PerformaQuantity);
            this.f.appStatus.setValue(data?.JeRecommended == "True" ? 1 : 0);
            this.f.jePVRemarks.setValue(data?.JeRemarks);
            
            this.f.misInstalled.setValue(data?.TypeOfMISInstalled);
            this.onSelectProgramme('update', data?.Vendor);

            let selVillage = this.villageList?.filter(val => val?.Code == data?.Village)[0];
            this.f.village.setValue(selVillage?.Name);
            this.selectedVillage = selVillage;

            for (let index = 0; index < data?.GPSCoordinates?.length; index++) {
              let geoData = {
                CornerID: data.GPSCoordinates[index].CornerID,
                lat: data.GPSCoordinates[index].Latitude,
                lng: data.GPSCoordinates[index].Longitude,
              };
              this.geolocationsarray.push(geoData);
            }
            if (this.geolocationsarray.length == 0) {
              this.mapEnable = false;
            } else {
              if (this.geolocationsarray && this.geolocationsarray.length > 0) {
                this.options.center = this.geolocationsarray[0];
              }
              this.mapEnable = true;
              this.geolocationsarray.forEach((row, index) => {
                this.addMarkers(row, index);
              });
              this.addOverlay();
            }
  
            for (let index = 0; index < data?.UploadAttachments?.length; index++) {
              let imagesData = {
                attachment: data.UploadAttachments[index].ImagePath,
                attachmentRawUrl: data.UploadAttachments[index].ImagePath,
                document_type: data.UploadAttachments[index].DocumentType,
                displayName: data.UploadAttachments[index].DocumentType,
                name: data.UploadAttachments[index].DocumentType,
              };
              this.documentList.push(imagesData);
            }
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }          
        },
        error: (err) => {
          this.displayUHBVNpvDialog = false;
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }

  // applyConditionalValidation(data) {
  //   if (data?.ApplicantType == '7500' && data?.ProgrammeName == 'Drip Irrigation') {
  //     this.submitEstimateForm.controls['rowSpacing'].setValidators([Validators.min(0.3)]);
  //     this.submitEstimateForm.controls['plantSpacing'].setValidators([Validators.min(0.6)]);
  //   }
  //   else {
  //     this.submitEstimateForm.controls['rowSpacing'].clearValidators();
  //     this.submitEstimateForm.controls['plantSpacing'].clearValidators();
  //     this.submitEstimateForm.controls['rowSpacing'].setValidators([Validators.required]);
  //     this.submitEstimateForm.controls['plantSpacing'].setValidators([Validators.required]);
  //   }
  //   this.submitEstimateForm.controls['rowSpacing'].updateValueAndValidity();
  //   this.submitEstimateForm.controls['plantSpacing'].updateValueAndValidity();
  // }

  // selectViewApplication(application, statusCode) {
  //   if (application.appID) {
  //     let statusCodeEncrypted = this.cryptoJsService.Encrypt(statusCode);
  //     const link = this.router.serializeUrl(
  //       this.router.createUrlTree([
  //         this.router.url.split('/')[1],
  //         'print',
  //         application.appID,
  //       ])
  //     );
  //     window.open(link, '_blank');
  //   } else {
  //     this.messageService.add({
  //       severity: 'error',
  //       summary: 'Error Message',
  //       detail: 'Invalid App ID',
  //     });
  //   }
  // }

  // downloadSheetAsPdf(modelData, filename) {
  //   this.cols = [
  //     { field: 'appID', header: 'appID' },
  //     { field: 'registerationDate_filter', header: 'date of Submit' },
  //     { field: 'registerationReassignDate_filter', header: 'date of Resubmit' },
  //     { field: 'ApplicantType', header: 'Applicant type' },
  //     { field: 'FarmerName', header: 'Farmer Name' },
  //     { field: 'village', header: 'village' },
  //     { field: 'block', header: 'block' },
  //     { field: 'district', header: 'district' },
  //     { field: 'AgeOfApplication', header: 'Age Of Application' },
  //     { field: 'ProgrammeName', header: 'Program Name' },
  //     { field: 'LandDetail', header: 'Land Detail' },
  //     { field: 'Total_Area', header: 'Total Area' },
  //     { field: 'Status_Ar', header: 'current status' },
  //     { field: 'DeptRemarks', header: 'Remarks' },
  //     { field: 'ActOnPrevAction', header: 'Act on PrevAction' },
  //   ];

  //   this.exportColumns = this.cols.map((col) => ({
  //     title: col.header,
  //     dataKey: col.field,
  //   }));

  //   import('jspdf').then((jsPDF) => {
  //     import('jspdf-autotable').then((x) => {
  //       const doc = new jsPDF.default(0, 0);
  //       doc.autoTable(this.exportColumns, modelData, { styles: { fontSize: 6 } });

  //       doc.save(`${filename}.pdf`);
  //     });
  //   });
  // }
  refreshTable() {
    // this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
    this.loadData(this.userId);
    // this.loadDataAndApplyFilter();
  }

  submitUHBVNSurvey(reqBody) {
    this._personalDetalSer
      .submitUHBVN_Letter_MI_PV(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(
            this.userId,
            'Request Letter for NOC',
            reqBody[0]?.appId,
            new Date(),
            resp,
            reqBody
          );
          if (resp == 'Success' || resp == 'success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });
            this.isSubmitted = true;
            this.onCloseDialog();
            this.loadData(this.userId);
            // this.loadDataAndApplyFilter();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: resp,
            });
          }

        },
        error: (err) => {
          this.activityRecordService.activityRecord(
            this.userId,
            'Request Letter for NOC',
            reqBody[0]?.appId,
            new Date(),
            err,
            reqBody
          );
          this.isSubmitted = true;
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  submitXenDetails(){
    if(this.xenRemarks == null || this.xenRemarks == '' || this.XenRecommended == null){
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Application Status and Enter Remarks',
      });
      return;
    }
    let surveyData = this.submitEstimateForm.value;
    const reqBody = [
      {
        "appId": this.selectedRow?.AppId,
        "cropId": surveyData?.cropId,
        "cropTypeId": surveyData?.cropType,
        "area": surveyData?.area,
        "killaNo": surveyData?.killNumber,
        "vendor": JSON.stringify(surveyData?.vendor?.Vendor_Code),
        "farmerMobile": surveyData?.mobileNo,
        "aadhaarNo": surveyData?.aadharNo,
        "farmer_Name": surveyData?.farmersName,
        "father_Name": surveyData?.fatherName,
        "fin_Year": surveyData?.finyear,
        "village": surveyData?.village?.Code,
        "networkId": this.ipAddress,
        "terminalId": this.ipAddress,
        "division": surveyData?.division,
        "residenceOf": surveyData?.address,
        "typeOfMISInstalled": surveyData?.misInstalled ? surveyData?.misInstalled : 0,
        "performaQuantity": Number(surveyData?.performaQunatity),
        "userId": this.userId,
        "jE_Recommended": surveyData?.appStatus,
        "jE_Remark": surveyData?.appStatus == 0 ? (surveyData?.nonRecReason?.code == 5 ? (surveyData?.remarksNonRec ? surveyData?.remarksNonRec : '') : surveyData?.nonRecReason?.name) : '',
        "xen_Recommended": this.XenRecommended,
        "xeN_Remark": this.xenRemarks,
        "letterDate": surveyData?.letterDate ? this.datePipe.transform(new Date(surveyData?.letterDate), 'yyyy-MM-dd') : surveyData?.letterDate,
        "sdo": surveyData?.sdo,
        "letterNo": surveyData?.letterNo,
        "insertServayAttachments": this.documentList,
        "gpsCoordinates": this.geolocationsarray,
        "DocPath": ""
      },
    ];

    this.submitUHBVNSurvey(reqBody);
  }

}
